import React, { Component } from 'react';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import "./TabControl.css";

import Header from "./Header";
import TimePrice from "./TimePrice";
import ModelNumber from "./ModelNumber";
import Notifications from "./Notifications";
import FeaturesRoot from "./FeaturesRoot";
import CdsFeatures from "./CdsFeatures";
import UrdUnits from "./UrdIUnits";
import NotesFeatures from "./NotesFeatures";
//import NumberPicker from "react-widgets/NumberPicker";
import { InputNumber } from "primereact/inputnumber"
import "primereact/resources/themes/mira/theme.css"

import LoaderView from "../../Components/Indicator/LoaderView";

import { requestBase, apiroot } from "./Fetch-helpers";
import ModalText from "../../Components/Spinner/ModalText";

export default class Configurator extends Component {

    constructor() {
        super();

        this.updateConfiguration = this.updateConfiguration.bind(this);
        this.updateCDS = this.updateCDS.bind(this);
        this.updateURD = this.updateURD.bind(this);
        this.updateNotes = this.updateNotes.bind(this);

        this.handleCloseModal = this.handleCloseModal.bind(this);

        this.state = {
            model: {}, cds: {}, urd: {}, notes: {}, models: [], notifications: {}, loading: true,
            crushing: false, crushReason: [],
            crushImage: {}, crushImageLoad: false,
            customModelNumber: false, debug: false,
            modelRoot: {}, countItems: 1,
            processed: false,
            showModal: false,
            textModal: '', viewCfgNotifications: true,

            totalPrice: "!!!", leadTime: "!!!",
            showHeaderPricenTime: false,//отображать цену/срок в шапке с автоматическим обновлением

        };

        window.onbeforeunload = (event) => {
            if (!this.state.processed) {
                let params = Configurator.getURLParams();

                if (params.cfgid) {
                    let res = navigator.sendBeacon(apiroot + "Configuration/SetValidationStatus/" + params.cfgid + "&4");
                }
            }
        }
    }

    static getURLParams() {

        const params = new Proxy(new URLSearchParams(window.location.search.toLowerCase()), {
            get: (searchParams, prop) => searchParams.get(prop),
        });
        return params;
    }

    async updateConfiguration(cfgData, cds = false, urd = false, notes = false) {

        if (cfgData == undefined) {
            await this.updateConfigurationAsync();
        } else {
            if (cfgData.isValid) {
                this.setState({ totalPrice: "!!!", leadTime: "!!!" });
                //cfgData.totalPrice = "!!!";//маркер загрузки
                //cfgData.leadTime = "!!!";
            }
            //this.updateValidData(cfgData);

            this.setState({ model: cfgData });
        }

        //const model = this.state.model;
        //if (model.isValid)
        //    await this.updatePrice();

        if (cds) {
            this.updateCDSAsync();
        }
        if (urd) {
            this.updateURDAsync();
        }
        if (notes) {
            this.updateNotesAsync();
        }

        await this.updateNotificationsAsync();
    }

    async updateValidData(cfgData) {
        //!!!await или блочить блок на время обновления?
        //let cfgData = this.state.model;
        if (cfgData.isValid) {

            //--!!!заглушка 
            //const _totalPrice = "Временно недоступно. Ведутся профилактические работы";
            //const _leadTime = _totalPrice;
            //this.setState({ totalPrice: _totalPrice, leadTime: _leadTime });
            //return;
            //++

            let up = this.updatePrice();
            let upt = this.updateProductionTime();

            const _totalPrice = await up;
            const _leadTime = await upt;

            this.setState({ totalPrice: _totalPrice, leadTime: _leadTime });
            //--
        }
    }

    async updateCDS(cdsData, cdsid) {
        this.setState({ cds: cdsData });

        let need_updateConfigurationAsync = false;
        for (const prm of cdsData.cdsParametrs)
            if (prm.id === cdsid && prm.mappingName) {
                need_updateConfigurationAsync = true;
                //await this.updateConfigurationAsync();
                break;
            }

        if (need_updateConfigurationAsync)
            await this.updateConfigurationAsync();

        this.updateNotificationsAsync();
    }

    updateURD(urdData) {
        this.setState({ urd: urdData });

        this.updateNotificationsAsync();
    }

    async updateNotes(notesData, paramid) {
        this.setState({ notes: notesData });

        let need_updateConfigurationAsync = false;
        for (const prm of notesData.cdsParametrs)
            if (prm.id === paramid && prm.mappingName) {
                need_updateConfigurationAsync = true;
                break;
            }

        if (need_updateConfigurationAsync)
            await this.updateConfigurationAsync();

        this.updateNotificationsAsync();
    }

    async updatePrice() {
        try {
            const params = Configurator.getURLParams();
            const response = await fetch(
                apiroot + "Configuration/GetTotalPrice/" + params.cfgid,
                Object.assign({}, requestBase, { method: "GET" }));

            if (!response.ok) {
                this.showResponseError(response, "Сервис расчета цены вернул ошибку");
                return;
            }

            const data = await response.text();
            return data;
            //const model = this.state.model;
            //model.totalPrice = data;
            ////this.setState({ model: data });
        }
        catch (err) {
            this.showError(err);
            return;
        }
    }

    async updateProductionTime() {
        try {
            const params = Configurator.getURLParams();
            const response = await fetch(
                apiroot + "Configuration/GetProductionTime/" + params.cfgid,
                Object.assign({}, requestBase, { method: "GET" }));

            if (!response.ok) {
                this.showResponseError(response, "Ошибка сервиса расчета срока изготовления");
                return;
            }

            const data = await response.text();
            return data;
            //const model = this.state.model;
            //model.leadTime = data;
            //this.setState({ model: data });
        }
        catch (err) {
            this.showError(err);
            return;
        }
    }

    async updateConfigurationAsync() {
        try {
            const params = Configurator.getURLParams();
            const response = await fetch(
                apiroot + "Configuration/" + params.cfgid + (params.count == null ? "" : "&" + params.count), //&count=
                Object.assign({}, requestBase, { method: "GET" }));

            if (!response.ok) {
                this.showResponseError(response, "Обновление конфигурации. Id=" + params.cfgid);
                return;
            }

            const data = await response.json();

            if (data.isValid) {
                this.setState({ totalPrice: "!!!", leadTime: "!!!" });
            }

            //this.updateValidData(data);

            this.setState({ model: data });
            console.log("Получена конфигурация. Id=" + data.id);
        }
        catch (err) {
            this.showError(err);
            return;
        }
    }

    async updateCDSAsync() {
        try {
            const params = Configurator.getURLParams();
            const response = await fetch(
                apiroot + "CDS/" + params.cfgid,
                Object.assign({}, requestBase, { method: "GET" }));

            if (!response.ok) {
                this.showResponseError(response, "Обновление CDS для UC=" + params.cfgid);
                return;
            }

            const data = await response.json();
            this.setState({ cds: data });
            console.log("Получены CDS. Id=" + data.id);
        }
        catch (err) {
            this.showError(err);
            return;
        }
    }

    async updateURDAsync() {
        try {
            const params = Configurator.getURLParams();
            const response = await fetch(
                apiroot + "URD/" + params.cfgid,
                Object.assign({}, requestBase, { method: "GET" }));

            if (!response.ok) {
                this.showResponseError(response, "Обновление URD для UC=" + params.cfgid);
                return;
            }

            const data = await response.json();
            this.setState({ urd: data });
            console.log("Получены URD. Id=" + data.id);
        }
        catch (err) {
            this.showError(err);
            return;
        }
    }

    async updateNotesAsync() {
        try {
            const params = Configurator.getURLParams();
            const response = await fetch(
                apiroot + "Notes/" + params.cfgid,
                Object.assign({}, requestBase, { method: "GET" }));

            if (!response.ok) {
                this.showResponseError(response, "Обновление Notes для UC=" + params.cfgid);
                return;
            }

            const data = await response.json();
            this.setState({ notes: data });
            console.log("Получены Notes. Id=" + data.id);
        }
        catch (err) {
            this.showError(err);
            return;
        }
    }

    async updateNotificationsAsync() {
        try {
            const params = Configurator.getURLParams();
            const response = await fetch(
                apiroot + "Configuration/GetNotification/" + params.cfgid,
                Object.assign({}, requestBase, { method: "GET" }));

            if (!response.ok) {
                this.showResponseError(response, "Обновление Notifications для UC=" + params.cfgid);
                return;
            }

            const data = await response.json();
            this.setState({ notifications: data.messages.filter((f) => f.isError == false || (f.isError == true && f.status != 9)) });
        }
        catch (err) {
            this.showError(err);
            return;
        }
    }

    componentDidMount() {
        this.populateConfiguratorData();
        this.loadUiSettings();

        const _timeout = 1000 * 60 * 20; //20 минут (ms*sec*min)
        setTimeout(() => {
            this.sendTimeout();
            this.setCrushing({ source: "TIMEOUT", title: "Время сессии истекло", detail: "Продолжить конфигурирование не возможно" });
        }, _timeout);
    }

    async loadUiSettings() {
        try {
            //Настройки UI клиента из статического конфиг-файла public/config.json
            const response = await fetch("config.json");
            if (response.ok) {
                const cfg = await response.json();
                this.setState({ showHeaderPricenTime: !!cfg.showHeaderPricenTime });
            }
        }
        catch (err) {
            //настройки не загрузились — остаётся значение по умолчанию (false)
        }
    }

    componentDidCatch() {
    }

    async sendTimeout() {
        const params = Configurator.getURLParams();

        fetch(apiroot + "Configuration/SetValidationStatus/" + (params.cfgid == null ? "" : params.cfgid) + "&3",
            Object.assign({}, requestBase, { method: "GET" }));
    }

    render() {
        const params = Configurator.getURLParams();
        const welcome = params.modelid == null && params.cfgid == null;
        const shortmode = params.shortmode == null ? false : true;

        if (this.state.crushing) {
            if (Object.keys(this.state.crushImage).length === 0 && !this.state.crushImageLoad) {
                this.setState({ crushImageLoad: true });
                this.getSource("crush-wall.png");
            }
            const errors = this.renderErrors(this.state.crushReason);

            return (
                <div className="error">
                    <img alt=" " src="./static/media/crush-wall.png" />
                    {errors}
                </div>
            )
        }
        else if (!welcome) {

            const debug = this.state.debug;

            if (this.state.loading) {
                let menu = this.renderMenuButtons(false, false, false);
                const errors = this.renderErrors(this.state.crushReason);

                return (
                    <div className="container-fluid">
                        <div className="stickyHeading">
                            {menu}
                        </div>
                        {errors}
                        <LoaderView header='Загрузка данных...' footer='Пожалуйста, подождите!' />
                    </div>
                );
            } else if (shortmode) {
                const model = this.state.model;
                const messages = this.state.notifications;
                const errors = this.renderErrors(this.state.crushReason);
                //let menu = this.renderMenuButtons(true, true, processEnable, debug);
                let headers = this.state.loading
                    ? <div />
                    : this.renderCfgHeaders(model, true);
                let contentParams = this.state.loading
                    ? <div><LoaderView header='Загрузка данных...' footer='Пожалуйста, подождите!' /></div>
                    : this.renderCfgBody(model, debug);
                let contentHelp = this.state.loading
                    ? <div><LoaderView header='Загрузка данных...' footer='Пожалуйста, подождите!' /></div>
                    : this.renderHelpBody(debug);
                let notifications = this.state.loading
                    ? <div />
                    : this.renderCfgNotifications(messages /*model.messages*/);

                return (
                    <div className="main">
                        <Tabs>
                            <div className="stickyHeading">
                                {/*{menu}*/}
                                {headers}
                                {notifications}
                                {errors}
                                <TabList>
                                    <Tab title="Список параметров строки заказа">Параметры</Tab>
                                    <Tab title="Справка" className="react-tabs__tab tab-list-right">Справка</Tab>
                                </TabList>
                            </div>
                            <div id="stickyHeadingBody" className="stickyHeading2">
                                <TabPanel>
                                    {contentParams}
                                </TabPanel>
                                <TabPanel>
                                    {contentHelp}
                                </TabPanel>
                            </div>
                        </Tabs>
                    </div>
                );
            }
            else {

                const model = this.state.model;
                const cds = this.state.cds;
                const cdsGroups = this.state.modelRoot.cds.cdsGroups;
                const urd = this.state.urd;
                const urdGroups = this.state.modelRoot.urd.units.length === 0 ? [] : this.state.modelRoot.urd.units[0].cdsGroups;
                const notes = this.state.notes;
                const notesGroups = this.state.modelRoot.notes.cdsGroups;
                const messages = this.state.notifications;
                const processEnable = model.isValid
                    && (cds.isValid === undefined || cds.isValid)
                    && (urd.isValid === undefined || urd.isValid)
                    && (notes.isValid === undefined || notes.isValid);

                const errors = this.renderErrors(this.state.crushReason);

                let menu = this.renderMenuButtons(true, true, processEnable, debug);

                let headers = this.state.loading
                    ? <div />
                    : this.renderCfgHeaders(model);

                let contentParams = this.state.loading
                    ? <div><LoaderView header='Загрузка данных...' footer='Пожалуйста, подождите!' /></div>
                    : this.renderCfgBody(model, debug);

                let contentCDS = this.state.loading
                    ? <div><LoaderView header='Загрузка данных...' footer='Пожалуйста, подождите!' /></div>
                    : this.renderCDSBody(model.id, cds, cdsGroups, debug);

                let contentURD = this.state.loading
                    ? <div><LoaderView header='Загрузка данных...' footer='Пожалуйста, подождите!' /></div>
                    : this.renderURDBody(model.id, urd, urdGroups, debug);

                let contentNotes = this.state.loading
                    ? <div><LoaderView header='Загрузка данных...' footer='Пожалуйста, подождите!' /></div>
                    : this.renderNotesBody(model.id, notes, notesGroups, debug);

                let contentHelp = this.state.loading
                    ? <div><LoaderView header='Загрузка данных...' footer='Пожалуйста, подождите!' /></div>
                    : this.renderHelpBody(debug);

                let notifications = this.state.loading
                    ? <div />
                    : this.renderCfgNotifications(messages /*model.messages*/);

                let modal = this.state.showModal
                    ? this.state.textModal
                    : <div />;

                const pricetimetab = !this.state.showHeaderPricenTime ? (<></>)
                    : (<Tab title="Данные срока изготовления и стоимость">Срок и Стоимость</Tab>);
                let pricetime = !this.state.showHeaderPricenTime ? (<></>)
                    : (<TabPanel><TimePrice URLParams={Configurator.getURLParams()} modelisValid={model.isValid}></TimePrice></TabPanel>);

                return (
                    <div className="main">
                        <Tabs>
                            <div className="stickyHeading">
                                <div className="modal">{modal}</div>
                                {menu}
                                {headers}
                                {notifications}
                                {errors}
                                <TabList>
                                    <Tab title="Список параметров строки заказа">Параметры</Tab>
                                    <Tab title="Общие расширенные настройки">CDS</Tab>
                                    <Tab title="Данные для каждой единицы">URD</Tab>
                                    <Tab title="Примечания для производства">Примечания</Tab>
                                    <Tab title="Справка" className="react-tabs__tab tab-list-right">Справка</Tab>
                                    {pricetimetab}
                                </TabList>
                            </div>
                            <div id="stickyHeadingBody" className="stickyHeading2">
                                <TabPanel>
                                    {contentParams}
                                </TabPanel>
                                <TabPanel>
                                    {contentCDS}
                                </TabPanel>
                                <TabPanel>
                                    {contentURD}
                                </TabPanel>
                                <TabPanel>
                                    {contentNotes}
                                </TabPanel>
                                <TabPanel>
                                    {contentHelp}
                                </TabPanel>
                                {pricetime}
                            </div>
                        </Tabs>
                    </div>
                );
            }
        } else {
            const models = this.state.models;

            let welcomeView = this.state.loading
                ? <div className="stickyHeading"><LoaderView header='Загрузка данных...' footer='Пожалуйста, подождите!' /></div>
                : this.renderWelcome(models);

            const errors = this.renderErrors(this.state.crushReason);

            return (
                <div className="main">
                    <div className="heading">
                        ВВЕДИТЕ КОЛИЧЕСТВО:&nbsp;&nbsp;
                        <InputNumber
                            showButtons
                            locale="ru-RU"
                            onChange={e => this.setState({ countItems: e.value })}
                            step={1}
                            max={100}
                            min={1}
                            value={this.state.countItems}
                            minFractionDigits={0}
                            maxFractionDigits={0}
                        />

                        {/*<NumberPicker*/}
                        {/*    defaultValue={this.state.countItems}*/}
                        {/*    step={1}*/}
                        {/*    max={100}*/}
                        {/*    min={1}*/}
                        {/*    precision={0}*/}
                        {/*    messages={{*/}
                        {/*        increment: `Увеличить на ${1}`,*/}
                        {/*        decrement: `Уменьшить на ${1}`,*/}
                        {/*    }}*/}
                        {/*    onChange={value => this.setState({ countItems: value })}*/}

                        {/*/>*/}
                    </div>
                    <div className="heading">
                        СПИСОК МОДЕЛЕЙ:
                    </div>
                    {errors}
                    {welcomeView}
                </div>
            );
        }
    }

    renderCfgNotifications(notif) {
        return notif && notif.length > 0 && (
            <div class="notifblock">
                <input type="checkbox" checked={this.state.viewCfgNotifications} onChange={this.handleviewCfgNotifications} id="notifblock_checkbox"></input>
                <label for="notifblock_checkbox" class="notifblock_label notifications-FailRule">Уведомления</label>
                <div class="notifblocktext">
                    <Notifications messages={notif} />
                </div>
            </div>
        )
    }

    handleviewCfgNotifications = () => {
        this.setState({ viewCfgNotifications: !this.state.viewCfgNotifications });
    }

    getSource = (path) => {
        this.getSourcCrushImagee(path);
    }

    getSourcCrushImagee = (path) => {
        const data = this.getSourceAsync(path);
        this.setState({ crushImage: data });
    }

    async getSourceAsync(path) {
        const response = await fetch(apiroot + "Configuration/GetSource",
            Object.assign({}, requestBase, {
                method: "post",
                headers: {
                    'Accept': 'application/json,text/plain',// application/json, 
                    'Content-Type': 'text/plain' //;charset=UTF-8
                },
                body: path   //JSON.stringify(
            }));

        if (response.ok) {

            const data = await response.json();
            return data;
        }
        else {
            console.log("Не удалось выполнить api/Configuration/GetSource");
        }
    }

    renderCfgHeaders(model, shortmode) {
        const leadTime = model.isValid ? this.state.leadTime : "";
        const price = model.isValid ? this.state.totalPrice : "";

        if (shortmode)
            return (
                <div className="tableheadershortmode">
                    <table>
                        <tr>
                            <td width="100%">
                                <ModelNumber modelNumber={model.modelNumber} updateConfiguration={this.populateConfiguratorData} isValid={model.isValid} handleToggle={this.ToggleButton} isCustomModelString={this.state.customModelNumber} />
                            </td>
                            <td class="tdbutton">
                                <button id="toggleEditModelNumber" onClick={this.ToggleButton}  /*disabled={!model.isValid}*/
                                    className={`glow-button-toggle ${this.state.customModelNumber ? "glow-button-toggle-on" : "glow-button-toggle-off"}`}
                                    title={this.state.customModelNumber ? "Нажмите, чтобы отменить редактирование" : "Нажмите, чтобы редактировать строку"}
                                >
                                </button>
                            </td>
                        </tr>
                    </table>
                </div >
            )

        return (
            <div className="tableheader">
                <table >
                    <tr>
                        <td class="tdimage">
                            <img src={this.state.modelRoot != undefined && this.state.modelRoot.imagePath != undefined ? "./static/media/" + this.state.modelRoot.imagePath : ""} />
                        </td>

                        <tr>
                            <td>
                                <Header modelDescription={model.description} cfgLeadTime={leadTime} cfgPrice={price} showPricenTime={this.state.showHeaderPricenTime} />
                            </td>
                        </tr>
                        <tr>
                            <td width="100%">
                                <ModelNumber modelNumber={model.modelNumber} updateConfiguration={this.populateConfiguratorData} isValid={model.isValid} handleToggle={this.ToggleButton} isCustomModelString={this.state.customModelNumber} />
                            </td>
                            <td class="tdbutton">
                                <button id="toggleEditModelNumber" onClick={this.ToggleButton}  /*disabled={!model.isValid}*/
                                    className={`glow-button-toggle ${this.state.customModelNumber ? "glow-button-toggle-on" : "glow-button-toggle-off"}`}
                                    title={this.state.customModelNumber ? "Нажмите, чтобы отменить редактирование" : "Нажмите, чтобы редактировать строку"}
                                >
                                </button>
                            </td>
                        </tr>
                        <tr class="headingHint">
                            <td>
                                {this.state.customModelNumber ? "Введите строку и нажмите <Enter>, чтобы произвести конфигурирование по строке" : ""}
                            </td>
                        </tr>
                    </tr>
                </table>
            </div>
        )
    }

    renderCfgBody(model, debug) {
        const extDisable = model.externalEnable != undefined && model.externalEnable == "false";
        return (
            <div>
                <FeaturesRoot extDisable={extDisable} configurationId={model.id} debug={debug} features={model.features} filterUser={this.filterUser} updateConfiguration={this.updateConfiguration} showError={this.showError} />
            </div>
        )
    }

    renderCDSBody(configurationId, cds, groups, debug) {
        const extDisable = cds.externalEnable != undefined && cds.externalEnable == "false";
        return (
            <div>
                <CdsFeatures extDisable={extDisable} configurationId={configurationId} cdsId={cds.id} debug={debug} features={cds.cdsParametrs} groups={groups}
                    handleUpdate={this.updateCDS} showError={this.showError} updateConfiguration={this.updateConfiguration} />
            </div>
        )
    }

    renderURDBody(configurationId, urd, groups, debug) {
        return (
            <div>
                <UrdUnits configurationId={configurationId} urdId={urd.id} debug={debug} units={urd.units} groups={groups}
                    handleUpdate={this.updateURD} showError={this.showError} updateConfiguration={this.updateConfiguration} />
            </div>
        )
    }

    renderNotesBody(configurationId, notes, groups, debug) {
        const extDisable = notes.externalEnable != undefined && notes.externalEnable == "false";
        return (
            <div>
                <div className="features">
                    <NotesFeatures extDisable={extDisable} configurationId={configurationId} notesId={notes.id} debug={debug} features={notes.cdsParametrs} groups={groups}
                        handleUpdate={this.updateNotes} showError={this.showError} updateConfiguration={this.updateConfiguration} />
                </div>
            </div>
        )
    }

    handleDownloadDoc() {
        //const enviroment = 'PILOT';
        const fileurl = 'L:/$CP/res/manuals/software-instructions/Инструкция пользователя НК.docx';
        window.open(fileurl, null);
    }

    async downloadFile() {
        const response = fetch(
            apiroot + "Configuration/GetInstruction/",
            Object.assign({}, requestBase, { method: "GET" }))
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(new Blob([blob]));

                const link = document.createElement('a');
                link.href = url;
                link.download = 'Инструкция пользователя НК.docx';

                document.body.appendChild(link);

                link.click();

                link.parentNode.removeChild(link);
            })
            .catch(rejected => {
                // console.log(rejected);
            });
    }

    renderHelpBody(debug) {
        return (
            <div className="main" style={{ padding: "10px 20px" }}>
                <button onClick={this.downloadFile} title="Скачать инструкцию пользователя в файле Word" className="glow-button">Скачать инструкцию</button>

                <h2>СБРОСИТЬ конфигурацию</h2>
                <div>
                    Кнопка "СБРОСИТЬ" удаляет введенные данные по конфигурации и приводит её в исходное состояние.
                </div>
                <h2>ПРОЦЕСС</h2>
                <div>
                    Кнопка "ПРОЦЕСС" завершает конфигурирование. Становится доступной, если выбраны все обязательные параметры, а также CDS и URD прошли валидацию и не содержат ошибок.
                </div>
                <h2>Поле сообщений</h2>
                <div>
                    Между строкой заказа и частью окна с параметрами и CDS/URD данными располагается поле, в котором выводятся разные сообщения.
                    При этом синим цветом выделяются информационные сообщения (ознакомительные), а красным - разного рода ошибки, которые необходимо устранить.
                </div>
                <h2>Подсказки</h2>
                <div>
                    <ul>
                        <li>Если навести курсор мыши на параметр/опцию, то будет выведено высплывающее сообщение с подсказкой или ошибкой или другой актуальной информацией.
                            Также выводится всплывающее сообщение с комментарием, если навести курсор мыши на цветной прямоугольник (см. пункт "Цветовая дифференциация").</li>
                        <li>Группы параметров на вкладках CDS/URD/Примечания можно сворачивать и разворачивать, если кликнуть левой кнопкой на заголовок группы.</li>
                    </ul>
                </div>
                <h2>Цветовая дифференциация</h2>
                <div style={{ border: "1px solid grey" }}>
                    <h3>Параметры строки заказа:</h3>
                    <table className="features" border="1" table-layout="fixed">
                        <tbody>
                            <tr>
                                <td className="grnOptFea"></td>
                                <td>Выбрана опция для параметра. Валидация пройдена.</td>
                            </tr>
                            <tr>
                                <td className="yellowOptFea"></td>
                                <td>Для параметра не выбрана опция. Выбор необязателен.</td>
                            </tr>
                            <tr>
                                <td className="redOptFea"></td>
                                <td>Для параметра не выбрана опция. Необходимо выбрать опцию.</td>
                            </tr>
                            <tr>
                                <td className="greyOptFea"></td>
                                <td>Параметр недоступен для выбора (нельзя выбрать ни одной опции).</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p />
                <div style={{ border: "1px solid grey" }}>
                    <h3>Параметры на вкладках CDS/URD/Примечания:</h3>
                    <table className="features" border="1" table-layout="fixed">
                        <tbody>
                            <tr>
                                <td className="grnOptFea"></td>
                                <td>Параметр CDS выбран или задан правильно (прошёл валидацию).</td>
                            </tr>
                            <tr>
                                <td className="redOptFea"></td>
                                <td>Параметр CDS выбран или задан, но неправильно (противоречит правилам валидации).</td>
                            </tr>
                            <tr>
                                <td className="greyOptFea"></td>
                                <td>CDS параметр в процессе редактирования пользователем.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
    closeError(ind) {
        let r = this.state.crushReason;
        if (r && r.length > ind) {
            r.splice(ind, 1);
            this.setState({ crushReason: r });
        }
    }
    renderErrors(errors) {
        if (errors && errors.length > 0)
            return (
                <div className="errors">
                    <h4 class="header2">Произошла непредвиденная ошибка!</h4>
                    {errors.map((err, index) => (
                        <div className="erroritem">
                            <button className="errorsbutton" aria-label="Dismiss" onClick={() => { this.closeError(index) }}>×</button>
                            <span class="title"><u><b>{err.source == "back" ? "BACKEND" : "FRONTEND"}</b>: {err.title}</u></span>
                            <span class="message">{err.detail}</span>
                            <p class="bottom">В случае повторения ошибки обратитесь к разработчикам сайта: ПГ Метран, САБП: <b>{err.source == "back" ? "Михаил Майоров" : "ServiceDesk"}</b></p>
                        </div>
                    ))}
                </div>
            )

        return (<></>);
    }

    renderMenuButtons(refreshEnable, resetEnable, processEnable, debug) {
        const tdBeta = Configurator.checkHostPort("ruchetabpzzz01", 5005) ?
            this.renderTdForVersion("Beta") : "";
        const tdAlfa = Configurator.checkHostPort("ruchetabpzzz01", 5000) ?
            this.renderTdForVersion("Alfa") : "";

        return (
            <div>
                <div class="radioButton"><button class="glow-button" onClick={this.resetConfiguratorData} disabled={!resetEnable} title="Нажмите, чтобы сбросить конфигурацию" >СБРОСИТЬ</button></div>
                <div class="radioButton"><button class="glow-button" onClick={this.processConfiguration} disabled={!processEnable} title="Нажмите, чтобы закончить конфигурирование" >ПРОЦЕСС</button></div>
                <div class="radioButton"><button class="glow-button" onClick={this.processCalc} disabled={!processEnable} title="Нажмите, чтобы закончить конфигурирование" >Калькуляция</button></div>
                {tdBeta}
                {tdAlfa}

                {/*    <tr>*/}
                {/*        <td class="buttons-table">*/}
                {/*            <button class="glow-button" onClick={this.resetConfiguratorData} disabled={!resetEnable} title="Нажмите, чтобы сбросить конфигурацию" >СБРОСИТЬ</button>*/}
                {/*        </td>*/}
                {/*        <td class="buttons-table">*/}
                {/*            <button class="glow-button" onClick={this.processConfiguration} disabled={!processEnable} title="Нажмите, чтобы закончить конфигурирование" >ПРОЦЕСС</button>*/}
                {/*        </td>*/}
                {/*        <td class="buttons-table">*/}
                {/*            <button class="glow-button" onClick={this.processCalc} disabled={!processEnable} title="Нажмите, чтобы закончить конфигурирование" >Калькуляция</button>*/}
                {/*        </td>*/}
                {/*        {tdBeta}*/}
                {/*        {tdAlfa}*/}
                {/*    </tr>*/}
            </div>
        )
    }
    renderTdForVersion(who) {
        const title = who + "-версия. Определяется по url (хост:порт)";
        const message = who.toLowerCase() == "beta" ?
            "ВЕРСИЯ ДЛЯ ТЕСТИРОВАНИЯ ЗАКАЗЧИКОМ !" :
            "ВЕРСИЯ ДЛЯ ПРОГРАММИСТОВ САБП !";
        return (
            <td className={`${who.toLowerCase()} versionMessage`} title={title} >
                {message}
            </td>
        );
    }
    static checkHostPort(host, port) {
        const searchHost = window.location.href.match(host);
        const searchPort = window.location.href.match("\:" + port);
        return searchHost != null && searchHost.length > 0 && searchPort != null && searchPort.length > 0;
    }

    renderWelcome(models) {
        return (
            <div>
                <ul className="modelslist">
                    {models && models
                        .map((model, index) => (
                            <div key={index}>
                                <button title="Нажмите, чтобы перейти к конфигурированию продукта" class="glow-button" onClick={() => {
                                    window.location.href = window.location.origin + "?modelId=" + model.id + "&count=" + this.state.countItems;
                                    //window.location.href = window.location.origin + "?modelId=" + model.id + "&revision=" + model.revision + "&count=" + this.state.countItems; !!!revision
                                }}>
                                    {model.imagePath &&
                                        <div class="tdimagemodelslist">
                                            <img src={model.imagePath != undefined ? "./static/media/" + model.imagePath : ""} />
                                        </div>
                                    }
                                    <div className={model.imagePath ? "imgtext" : ""}>
                                        {model.name} {!model.revision ? "" : "(" + model.revision + ")"} {model.description == null ? "" : "(" + model.description + ")"}
                                    </div>
                                </button>
                            </div>
                        ))}
                </ul>
            </div>
        )
    }

    ToggleButton = () => {
        this.setState({ customModelNumber: !this.state.customModelNumber });
        if (!this.state.customModelNumber) {
            var textbox = document.getElementById("toggleEditModelNumber");
            if (this.state.model.isValid) {
                textbox.value = this.state.model.modelNumber;
            }
            else {
                textbox.value = "";
            }
        }
    }

    handleClickRefresh() {
        this.populateConfiguratorData();
    };

    async handleClickReset() {
        this.resetConfiguratorData();
    };

    processConfiguration = () => {
        this.processConfigurationAsync();
    };
    async processConfigurationAsync() {
        const wind = window;
        const params = Configurator.getURLParams();
        const response = await fetch(apiroot + "Configuration/Process/" + (params.cfgid == null ? "" : params.cfgid), Object.assign({}, requestBase, { method: "GET" }));
        const err = await response.json();
        if (!response.ok) {
            this.addCrushReason({ source: "back", title: err.title, detail: err.detail });
            return;
        }
        else {
            this.setState({ processed: true }, () => { wind.open(wind.location, '_self').close(); });
        }
    }

    handleCloseModal(notesData) {
        this.setState({ showModal: false });
    }

    processCalc = () => {
        this.processCalcAsync();
    };

    async processCalcAsync() {
        let params = Configurator.getURLParams();
        let that = this;
        const response = fetch(
            apiroot + "Configuration/GetTotalPrice/" + (params.cfgid == null ? "" : params.cfgid),
            Object.assign({}, requestBase, { method: "GET" }))
            .then(response => response.json());

        response.then(response => {
            let cont = (
                <ModalText handleCloseModal={that.handleCloseModal} dataresponse={response} >
                </ModalText>

            )

            that.setState({ showModal: true, textModal: cont });
        })
            .catch(rejected => {
                this.showError("Не получены данные калькуляции");
            });
    }

    //async processCalcAsync() {
    //    let params = Configurator.getURLParams();

    //    const response = fetch(
    //        apiroot + "Configuration/GetCosting/" + (params.cfgid == null ? "" : params.cfgid),
    //        Object.assign({}, requestBase, { method: "GET" }))
    //        .then(response => response.blob())
    //        .then(blob => {
    //            const url = window.URL.createObjectURL(new Blob([blob]));

    //            const link = document.createElement('a');
    //            link.href = url;
    //            link.download = 'CALCZNP.csv';

    //            document.body.appendChild(link);

    //            link.click();

    //            link.parentNode.removeChild(link);
    //        })
    //        .catch(rejected => {
    //            this.addCrushReason({ source: "back", title: "GetCosting", detail: rejected });
    //        });
    //}

    populateConfiguratorData = (ConfigureData) => {
        this.populateConfiguratorDataAsync(ConfigureData);
    }
    async populateConfiguratorDataAsync(ConfigureData) {

        const params = Configurator.getURLParams();
        const debug = params.debug == null ? false : true;
        this.setState({ debug: debug });

        if (params.modelid == null && params.cfgid == null) {
            try {
                const response0 = await fetch(apiroot + "Model/GetModels", Object.assign({}, requestBase, { method: "GET" }));
                if (!response0.ok) {
                    this.showResponseError(response0, "Получение моделей (GetModels)");
                    return;
                }
                const data0 = await response0.json();

                this.setState({ loading: false, models: data0, crushReason: [] });
            }
            catch (err) {
                this.showError(err);
                this.setState({ loading: false });
            }
        }
        else {

            //this.setState({ crushing: false, crushReason: "" });

            try {
                if (params.modelid == null) {
                    this.setState({ loading: true });

                    let data1 = ConfigureData;
                    if (!ConfigureData) {
                        const response1 = await fetch(
                            apiroot + "Configuration/" + (params.cfgid == null ? "" : params.cfgid) + (params.count == null ? "" : "&" + params.count),  //&count=
                            Object.assign({}, requestBase, { method: "GET" }));
                        if (!response1.ok) {
                            this.showResponseError(response1, "Получение конфигурации UC=" + params.cfgid);
                            return;
                        }
                        data1 = await response1.json();
                    }
                    const response2 = await fetch(apiroot + "Model/GetClient/" + data1.modelId + (data1.modelRevision ? "&" + data1.modelRevision : ""), Object.assign({}, requestBase, { method: "GET" }));
                    //const response2 = await fetch(apiroot + "Model/GetClient/" + data1.modelId, Object.assign({}, requestBase, { method: "GET" }));
                    //const response2 = await fetch(apiroot + "Model/" + data1.modelId, Object.assign({}, requestBase, { method: "GET" }));                    
                    const response3 = fetch(apiroot + "CDS/" + params.cfgid, Object.assign({}, requestBase, { method: "GET" }));
                    const response4 = fetch(apiroot + "URD/" + params.cfgid, Object.assign({}, requestBase, { method: "GET" }));
                    const response5 = fetch(apiroot + "Configuration/GetNotification/" + params.cfgid, Object.assign({}, requestBase, { method: "GET" }));
                    const response6 = fetch(apiroot + "Notes/" + params.cfgid, Object.assign({}, requestBase, { method: "GET" }));

                    const res2 = await response2;
                    if (!res2.ok) {
                        this.showResponseError(res2, "Получение модели Model=" + data1.modelId);
                        return;
                    }
                    const res3 = await response3;
                    if (!res3.ok) {
                        this.showResponseError(res3, "Получение CDS для UC=" + params.cfgid);
                        return;
                    }
                    const res4 = await response4;
                    if (!res4.ok) {
                        this.showResponseError(res4, "Получение URD для UC=" + params.cfgid);
                        return;
                    }
                    const res5 = await response5;
                    if (!res5.ok) {
                        this.showResponseError(res5, "Получение Notifications для UC=" + params.cfgid);
                        return;
                    }
                    const res6 = await response6;
                    if (!res6.ok) {
                        this.showResponseError(res6, "Получение Notes для UC=" + params.cfgid);
                        return;
                    }
                    //console.time("bef")
                    //console.timeLog("bef")
                    const data2 = await res2.json();
                    const data3 = await res3.json();
                    const data4 = await res4.json();
                    const data5 = await res5.json();

                    // показываем сообщение типа alert, чтобы "заострить внимание" пользователя
                    if (data5.messages != null && data5.messages.length > 0) {
                        const alerts = data5.messages.filter((f) => f.isError == true && f.status == 9); // status = OperationStatus.Alert (Backend)
                        if (alerts.length > 0) {
                            for (const msg of alerts) {
                                alert(msg.messageText);
                            }
                        }
                    }
                    const data6 = await res6.json();

                    //if (data1.isValid) {
                        //this.updateValidData(data1);
                        //let up = this.updatePrice();
                        //let upt = this.updateProductionTime();

                        //data1.totalPrice = await up;
                        //data1.leadTime = await upt;
                    //}

                    this.setState(
                        {
                            modelRoot: data2,
                            model: data1, cds: data3, urd: data4, notes: data6,
                            notifications: data5.messages.filter((f) => f.isError == false || (f.isError == true && f.status != 9)),
                            loading: false, debug: debug
                        }
                    );
                }
                else {
                    const response1 = await fetch(apiroot + "Configuration/New?modelId=" + params.modelid
                        + (params.revision ? "&revision=" + params.revision : "")
                        + "&count=" + params.count,
                        Object.assign({}, requestBase, { method: "GET" }));
                    if (!response1.ok) {
                        this.showResponseError(response1, "Попытка создания новой конфигурации для Model=" + params.modelid);
                        return;
                    }
                    const data1 = await response1.json();
                    window.location.href = window.location.origin + "?cfgId=" + data1.id;
                    return;
                }
            }
            catch (err) {
                this.showError(err);
                this.setState({ loading: false });
                return;
            }
        }
    }

    resetConfiguratorData = () => {
        this.resetConfiguratorDataAsync();
    }
    async resetConfiguratorDataAsync() {
        const params = Configurator.getURLParams();

        const response = await fetch(apiroot + "Configuration/Reset/" + (params.cfgid == null ? "" : params.cfgid),
            Object.assign({}, requestBase, {
                method: "post",
                headers: {
                    'Accept': 'application/json, text/plain',
                    'Content-Type': 'application/json;charset=UTF-8'
                },
                body: JSON.stringify(Error)
            }));

        if (!response.ok) {
            this.showResponseError(response, "Сброс для UC=" + params.cfgid);
            return;
        }

        const data = await response.json();
        if (data.isError)
            this.addCrushReason(data.messageText);
        else {
            this.populateConfiguratorDataAsync();
            this.updateNotificationsAsync();
        }
    }

    // Попытка разбора response, чтобы получить ошибку в формате json
    async showResponseError(response, message) {
        try {
            const err = await response.json();
            this.showError(err);
        }
        catch (err) {
            const err_ =
            {
                title: response.status + " (" + response.statusText + ")",
                detail: <p>{message}<p>URL: {response.url}</p></p>
            };
            this.showError(err_);
        }
    }

    setCrushing(err) {
        this.addCrushReason(err);
        this.setState({ crushing: true });
    }

    async addCrushReason(err) {
        let r = this.state.crushReason;
        if (!r) r = [];

        r.push(err);

        this.setState(
            {
                crushReason: r,
            });
    }

    findCrushReason(err) {
        let r = this.state.crushReason;
        if (!r) r = [];

        return r.some((x) => x.title === err);
    }

    showError = (err) => {
        if (err.name == undefined) {
            if (err.title != undefined) {
                //session
                if (err.title.startsWith("440"))
                    this.setCrushing({ source: "TIMEOUT", title: "Время сессии истекло", detail: "Продолжить конфигурирование не возможно" });
                else
                    this.addCrushReason({ source: "back", title: err.title, detail: err.detail });
            } else
                this.addCrushReason({ source: "back", title: "Неопределенная ошибка...", detail: err });
        } else {
            const mes = err.name + ' ' + err.message;
            const _f = !this.findCrushReason(mes);
            if (_f)
                this.addCrushReason({ source: "front", title: mes, detail: err.stack });
        }
    }
}